/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Filter_HintInputs */

const vi_einvoice_filter_hint = /** @type {(inputs: Einvoice_Filter_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bộ lọc theo kết quả đối soát trong ERP. Hóa đơn đã phát hành có thể vẫn nằm trong nhóm đang đối soát.`)
};

/**

* @param {Einvoice_Filter_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_filter_hint = /** @type {((inputs?: Einvoice_Filter_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Filter_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_filter_hint(inputs)
});